import { type ComponentPropsWithoutRef } from 'react';
import { cn } from '@/utils/tailwind.util';
export const Placeholder = ({
  placeholder,
  className,
  ...rest
}: {
  placeholder: string;
} & ComponentPropsWithoutRef<'div'>) => {
  return <div {...rest} tabIndex={-1} className={cn('absolute top-0 left-0 size-full flex items-center text-disabled text-heading-sm-bold', className)} data-sentry-component="Placeholder" data-sentry-source-file="Placeholder.tsx">
      {placeholder}
    </div>;
};